export const tr = {
    brandlift: 'Araştırmalar',
    'budget-limit-with-currency': 'Bütçe, {currency}',
    budgetLimit: 'Bütçe',
    'campaign-type': 'Kampanya türü',
    default: 'Manuel yönetim',
    goals: 'Dönüşümler',
    id: 'Id',
    name: 'Name',
    platform: 'Gösterim pozisyonları',
    settings: 'Ayarlar',
    status: 'Durum',
    strategy: 'Strateji',
    sum: 'Kalan',
    'sum-with-currency': 'Kalan, {currency}',
    type: 'Türü'
};
